// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import VueProgressBar from 'vue-progressbar';
import lodash from 'lodash';
import VueLodash from 'vue-lodash/dist/vue-lodash.min';
import VueCookie from 'vue-cookie';
import VueGtm from 'vue-gtm';
import VueAnalytics from 'vue-analytics';
import VueHead from 'vue-head';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueLodash, lodash);
Vue.use(VueHead);
Vue.use(Vuex);
Vue.use(VueCookie);
Vue.use(VueProgressBar, {
  transition: {
    speed: '0.6s',
    opacity: '0.3s',
    termination: 200,
  },
  autoRevert: true,
  color: 'rgb(0, 0, 0)',
  failedColor: 'red',
  height: '3px',
});
Vue.use(VueGtm, {
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'], // If router, you can exclude some routes name
});
Vue.use(VueAnalytics, {
  id: 'UA-106049798-1',
  router,
});

Vue.directive('colorize', {
  bind(el, binding) {
    const elm = el;
    elm.style.color = binding.value;
  },
});

Vue.filter('padToTwo', (value) => {
  let pad;
  if (value < 10) {
    pad = `0${value}`;
  } else {
    pad = value;
  }
  return pad;
});


Vue.filter('getAmount', (value) => {
  let amount = '';
  amount = value.toString().split('.');
  return amount[0];
});
Vue.filter('getCents', (value) => {
  let amount = '';
  amount = value.toString().split('.');
  if (amount[1] === '' || amount[1] == null) {
    amount = '00';
  } else {
    amount = amount[1];
  }
  return amount;
});

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  store: new Vuex.Store(store),
  router,
  template: '<App/>',
  components: { App },
  data() {
    return {
      basket: {
        products: [],
      },
      looks: {
        men: {
          1: {
            name: 'Look 1',
            hex_color: '#9296a3',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/1/slide.jpg',
              large: 'static/img/looks/men/1/large.jpg',
              platter: 'static/img/looks/men/1/platter.jpg',
              scenes: ['static/img/looks/men/1/scene_1.jpg', 'static/img/looks/men/1/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ VESTE GRIS', 'RUN DRY+ T SHIRT NOIR CHINE'],
              bottom: ['RUN WARM+ PANT NOIR'],
              shoes: ['RUN ACTIVE BLEU JAUNE'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES'],
            },
            references: [
              8395488,
              8381934,
              8394834,
              8379979,
              8325547,
            ],
          },
          2: {
            name: 'Look 2',
            hex_color: '#dcf78c',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/2/slide.jpg',
              large: 'static/img/looks/men/2/large.jpg',
              platter: 'static/img/looks/men/2/platter.jpg',
              scenes: ['static/img/looks/men/2/scene_1.jpg', 'static/img/looks/men/2/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ VESTE SANS MANCHE NOIR', 'RUN WARM+ MML JAUNE'],
              bottom: ['RUN DRY+ SHORT BY NIGHT', 'RUN DRY+ COLLANT PRINT'],
              shoes: ['RUN ACTIVE NOIR GRIS'],
              accessories: ['RUN LIGHT 250 GREY', 'BANDEAU BY NIGHT'],
            },
            references: [
              8394831,
              8394839,
              8381795,
              8394756,
              8379985,
              8369001,
              8369000,
            ],
          },
          3: {
            name: 'Look 3',
            hex_color: '#f05A3C',
            price: 79.99,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/3/slide.jpg',
              large: 'static/img/looks/men/3/large.jpg',
              platter: 'static/img/looks/men/3/platter.jpg',
              scenes: ['static/img/looks/men/3/scene_1.jpg', 'static/img/looks/men/3/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ VESTE ROUGE', 'RUN DRY+ T SHIRT ROUGE'],
              bottom: ['RUN WARM+ PANT GRIS'],
              shoes: ['RUN ACTIVE GRIS ROUGE'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES'],
            },
            references: [
              8395487,
              8381800,
              8394835,
              8379976,
              8325547,
            ],
          },
          4: {
            name: 'Look 4',
            hex_color: '#dce1e7',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/4/slide.jpg',
              large: 'static/img/looks/men/4/large.jpg',
              platter: 'static/img/looks/men/4/platter.jpg',
              scenes: ['static/img/looks/men/4/scene_1.jpg', 'static/img/looks/men/4/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ VESTE BY NIGHT', 'RUN DRY+ TSHIRT  NOIR CHINE'],
              bottom: ['RUN WARM+ COLLANT NOIR JAUNE'],
              shoes: ['RUN ELIORUN NOIR'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES', 'SGN 400'],
            },
            references: [
              8394841,
              8381934,
              8394843,
              8379984,
              8325547,
              8394633,
            ],
          },
          5: {
            name: 'Look 5',
            hex_color: '#000000',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/5/slide.jpg',
              large: 'static/img/looks/men/5/large.jpg',
              platter: 'static/img/looks/men/5/platter.jpg',
              scenes: ['static/img/looks/men/5/scene_1.jpg', 'static/img/looks/men/5/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ VESTE NOIR', 'RUN WARM+ MML NOIR CHINE'],
              bottom: ['RUN DRY + SHORT NOIR', 'RUN WARM+ COLLANT NOIR'],
              shoes: ['RUN ACTIVE NOIR GRIS'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES'],
            },
            references: [
              8395486,
              8394838,
              8381935,
              8394833,
              8379985,
              8325547,
            ],
          },
          6: {
            name: 'Look 6',
            hex_color: '#9296a3',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/6/slide.jpg',
              large: 'static/img/looks/men/6/large.jpg',
              platter: 'static/img/looks/men/6/platter.jpg',
              scenes: ['static/img/looks/men/6/scene_1.jpg', 'static/img/looks/men/6/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN RAIN VESTE NIGHT', 'RUN WARM+ MML GRIS'],
              bottom: ['RUN DRY+ SHORT NOIR', 'RUN WARM+  COLLANT NOIR'],
              shoes: ['RUN ELIOPRIME VERT'],
              accessories: ['EVOLUTIVE GLOVE BY NIGHT CHINE'],
            },
            references: [
              8394761,
              8394837,
              8381935,
              8394833,
              8379988,
              8393526,
              8394633,
            ],
          },
          7: {
            name: 'Look 7',
            hex_color: '#dcf78c',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/7/slide.jpg',
              large: 'static/img/looks/men/7/large.jpg',
              platter: 'static/img/looks/men/7/platter.jpg',
              scenes: ['static/img/looks/men/7/scene_1.jpg', 'static/img/looks/men/7/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ MML JAUNE'],
              bottom: ['RUN WARM+ PANT NOIR'],
              shoes: ['RUN EKIPRIME  BLEU JAUNE'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES'],
            },
            references: [
              8394839,
              8394834,
              8379974,
              8325547,
            ],
          },
          8: {
            name: 'Look 8',
            hex_color: '#dcf78c',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/8/slide.jpg',
              large: 'static/img/looks/men/8/large.jpg',
              platter: 'static/img/looks/men/8/platter.jpg',
              scenes: ['static/img/looks/men/8/scene_1.jpg', 'static/img/looks/men/8/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ VESTE SANS MANCHE JAUNE', 'RUN WARM+ MML NOIR'],
              bottom: ['RUN WARM+ COLLANT NOIR JAUNE'],
              shoes: ['RUN ELIORUN BLEU JAUNE'],
              accessories: ['EVOLUTIVE GLOVE BY NIGHT CHINE', 'SGN 400'],
            },
            references: [
              8394832,
              8394838,
              8394843,
              8379980,
              8393526,
              8394633,
            ],
          },
          9: {
            name: 'Look 9',
            hex_color: '#dce1e7',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/9/slide.jpg',
              large: 'static/img/looks/men/9/large.jpg',
              platter: 'static/img/looks/men/9/platter.jpg',
              scenes: ['static/img/looks/men/9/scene_1.jpg', 'static/img/looks/men/9/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN RAIN VESTE BLANCHE', 'RUN DRY+ T SHIRT NOIR CHINE'],
              bottom: ['RUN DRY+ SHORT NOIR', 'RUN WARM+ COLLANT'],
              shoes: ['RUN ACTIVE GRIP NOIR BLANC'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES'],
            },
            references: [
              8394760,
              8381934,
              8381935,
              8394833,
              8379981,
              8325547,
            ],
          },
          10: {
            name: 'Look 10',
            hex_color: '#f05A3C',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/10/slide.jpg',
              large: 'static/img/looks/men/10/large.jpg',
              platter: 'static/img/looks/men/10/platter.jpg',
              scenes: ['static/img/looks/men/10/scene_1.jpg', 'static/img/looks/men/10/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ COUPE VENT ROUGE', 'RUN WARM+ MML NOIR CHINE'],
              bottom: ['RUN WARM+ PANT NOIR'],
              shoes: ['RUN ELIOFEET NOIR'],
              accessories: '',
            },
            references: [
              8394758,
              8394838,
              8394834,
              8379975,
            ],
          },
          11: {
            name: 'Look 11',
            hex_color: '#000000',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/11/slide.jpg',
              large: 'static/img/looks/men/11/large.jpg',
              platter: 'static/img/looks/men/11/platter.jpg',
              scenes: ['static/img/looks/men/11/scene_1.jpg', 'static/img/looks/men/11/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN RAIN JACKET BLACK', 'RUN WARM+ MMLROUGE'],
              bottom: ['RUN WARM COLLANT PRINT'],
              shoes: ['RUN EKIPRIME BLEU ROUGE'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES'],
            },
            references: [
              8394759,
              8394842,
              8394756,
              8379987,
              8155432,
            ],
          },
          12: {
            name: 'Look 12',
            hex_color: '#f05A3C',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/12/slide.jpg',
              large: 'static/img/looks/men/12/large.jpg',
              platter: 'static/img/looks/men/12/platter.jpg',
              scenes: ['static/img/looks/men/12/scene_1.jpg', 'static/img/looks/men/12/scene_2.jpg'],
            },
            clothings: {
              top: ['RUN WARM+ MML ROUGE'],
              bottom: ['RUN WARM+ PANT NOIR'],
              shoes: ['RUN ACTIVE GRIP KAKI'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES'],
            },
            references: [
              8394842,
              8394834,
              8379986,
              8155432,
            ],
          },
        },
        women: {
          1: {
            name: 'Look 1',
            hex_color: '#78748b',
            price: 0.00,
            designers_word: 'Con il gilet senza maniche, il freddo non sarà più una scusa per non correre! La combinazione nero e grigio si modernizza grazie al motivo cartografico. Sii un jogger urbano fino in fondo!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/1/slide.jpg',
              large: 'static/img/looks/women/1/large.jpg',
              platter: 'static/img/looks/women/1/platter.jpg',
              scenes: ['static/img/looks/women/1/scene_1.jpg', 'static/img/looks/women/1/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8395605,
              8394798,
              8380664,
              8394797,
              8380028,
              8380908,
              8325547,
              8394633,
            ],
          },
          2: {
            name: 'Look 2',
            hex_color: '#f3532e',
            price: 0.00,
            designers_word: 'Questo outfit dona leggerezza e traspirabilità con un contrasto dinamico nero e corallo perfetto per la mezza stagione. Il corallo, è il nuovo colore fluo di moda!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/2/slide.jpg',
              large: 'static/img/looks/women/2/large.jpg',
              platter: 'static/img/looks/women/2/platter.jpg',
              scenes: ['static/img/looks/women/2/scene_1.jpg', 'static/img/looks/women/2/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394790,
              8367751,
              8380013,
              8380908,
              8325547,
              8393523,
            ],
          },
          3: {
            name: 'Look 3',
            hex_color: '#bbbdc3',
            price: 0.00,
            designers_word: 'Il semplice nero e grigio ti offriranno un outfit attuale e alla moda, assicurandoti sobrietà ed eleganza.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/3/slide.jpg',
              large: 'static/img/looks/women/3/large.jpg',
              platter: 'static/img/looks/women/3/platter.jpg',
              scenes: ['static/img/looks/women/3/scene_1.jpg', 'static/img/looks/women/3/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394796,
              8367751,
              8380028,
              8380908,
              8325547,
              8393523,
              8342130,
            ],
          },
          4: {
            name: 'Look 4',
            hex_color: '#f3532e',
            price: 0.00,
            designers_word: 'Dimentica il grigio delle giornate invernale e proteggiti dal vento con questo outfit corallo e arancione, per un look motivante e pieno di energia!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/4/slide.jpg',
              large: 'static/img/looks/women/4/large.jpg',
              platter: 'static/img/looks/women/4/platter.jpg',
              scenes: ['static/img/looks/women/4/scene_1.jpg', 'static/img/looks/women/4/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394768,
              8394780,
              8370294,
              8380013,
              8380908,
              8325547,
              8342130,
            ],
          },
          5: {
            name: 'Look 5',
            hex_color: '#782949',
            price: 0.00,
            designers_word: 'Il bordeaux è il colore di questo inverno. Il gioco di colori di questo outfit risvegliera la tua femminilità. Girly ma non troppo!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/5/slide.jpg',
              large: 'static/img/looks/women/5/large.jpg',
              platter: 'static/img/looks/women/5/platter.jpg',
              scenes: ['static/img/looks/women/5/scene_1.jpg', 'static/img/looks/women/5/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394794,
              8394783,
              8380019,
              8380908,
              8325547,
              8393521,
            ],
          },
          6: {
            name: 'Look 6',
            hex_color: '#FF1E8C',
            price: 0.00,
            designers_word: 'Metti in risalto la tua femminilità e sportività con il classico nero e rosa fucsia. Tecnicità e femminilità assicurate!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/6/slide.jpg',
              large: 'static/img/looks/women/6/large.jpg',
              platter: 'static/img/looks/women/6/platter.jpg',
              scenes: ['static/img/looks/women/6/scene_1.jpg', 'static/img/looks/women/6/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394779,
              8370294,
              8380012,
              8380909,
              8325547,
            ],
          },
          7: {
            name: 'Look 7',
            hex_color: '#006a84',
            price: 0.00,
            designers_word: 'In blu, con uno stile urbano, aggiungi colore e originalità alle tue corse!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/7/slide.jpg',
              large: 'static/img/looks/women/7/large.jpg',
              platter: 'static/img/looks/women/7/platter.jpg',
              scenes: ['static/img/looks/women/7/scene_1.jpg', 'static/img/looks/women/7/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394781,
              8394782,
              8380014,
              8380908,
              8325547,
            ],
          },
          8: {
            name: 'Look 8',
            hex_color: '#dce1e7',
            price: 0.00,
            designers_word: 'Con questa panoplie nera e bianca, libera la tua voglia di correre anche sotto la pioggia. La giacca impermeabile con inserti catarifrangenti ti assicurerà impermeabilità e stile con tutte le condizioni metereologiche.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/8/slide.jpg',
              large: 'static/img/looks/women/8/large.jpg',
              platter: 'static/img/looks/women/8/platter.jpg',
              scenes: ['static/img/looks/women/8/scene_1.jpg', 'static/img/looks/women/8/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394767,
              8394778,
              8381587,
              8380028,
              8380908,
              8393517,
            ],
          },
          9: {
            name: 'Look 9',
            hex_color: '#78748b',
            price: 0.00,
            designers_word: 'Gioca la sobrietà con un outfit nero e grigio con un dettaglio grafico e urbano.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/9/slide.jpg',
              large: 'static/img/looks/women/9/large.jpg',
              platter: 'static/img/looks/women/9/platter.jpg',
              scenes: ['static/img/looks/women/9/scene_1.jpg', 'static/img/looks/women/9/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394805,
              8380664,
              8394804,
              8380024,
              8380908,
              8393526,
              8393517,
              8394633,
              8325547,
            ],
          },
          10: {
            name: 'Look 10',
            hex_color: '#6ed5de',
            price: 0.00,
            designers_word: 'Con il pantalone Run Dry + e questo turchese, opta per un outfit fresco, perfetto per la mezza stagione.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/10/slide.jpg',
              large: 'static/img/looks/women/10/large.jpg',
              platter: 'static/img/looks/women/10/platter.jpg',
              scenes: ['static/img/looks/women/10/scene_1.jpg', 'static/img/looks/women/10/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394793,
              8381587,
              8380029,
              8380908,
              8325547,
            ],
          },
          11: {
            name: 'Look 11',
            hex_color: '#f3532e',
            price: 0.00,
            designers_word: 'Voglia di una corsa in compagnia della musica? Indossa la giacca Run Warm, pratica con il suo speciale passaggio per le auricolari. Osa con il bordeaux, per una delicata femminilità.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/11/slide.jpg',
              large: 'static/img/looks/women/11/large.jpg',
              platter: 'static/img/looks/women/11/platter.jpg',
              scenes: ['static/img/looks/women/11/scene_1.jpg', 'static/img/looks/women/11/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394802,
              8394803,
              8380019,
              8380908,
              8325547,
              8393521,
              8394633,
            ],
          },
          12: {
            name: 'Look 12',
            hex_color: '#2E4DA7',
            price: 0.00,
            designers_word: 'Per un outfit accessibile e morderno, la panoplie blu è perfetta per cambiare dal rosa, restando sportiva. Provaci!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/12/slide.jpg',
              large: 'static/img/looks/women/12/large.jpg',
              platter: 'static/img/looks/women/12/platter.jpg',
              scenes: ['static/img/looks/women/12/scene_1.jpg', 'static/img/looks/women/12/scene_2.jpg'],
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: [''],
            },
            references: [
              8394801,
              8367751,
              8380018,
              8380908,
              8325547,
            ],
          },
        },
      },
    };
  },
});
export default vm;



// WEBPACK FOOTER //
// ./src/main.js